import { compose, setDisplayName, withProps } from 'recompose';
import { Subject } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

const updateSettings$ = new Subject<boolean>();
const trackLoaded$ = new Subject<() => void>();

export const withTrackMediaManagerLoadedObservers = compose(
  setDisplayName('withTrackMediaManagerLoadedObservers'),
  withProps({
    updateSettings$,
    trackLoaded$,
  }),
);

export const createTrackMediaManagerLoadedSubscription = (updateSettings$, trackLoaded$) => {
  updateSettings$
    .pipe(switchMap(() => trackLoaded$.pipe(first())))
    .subscribe((trackMediaManagerLoaded) => trackMediaManagerLoaded());
};
